import * as React from 'react';

import throttle = require('lodash.throttle');

export interface InfiniteListProps {
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  threshold?: number;
  throttle?: number;
  className?: string;
}
export class InfiniteList extends React.Component<InfiniteListProps> {
  public static defaultProps: Pick<InfiniteListProps, 'threshold' | 'throttle'> = {
    threshold: 200,
    throttle: 64,
  };
  private sentinel: HTMLDivElement;

  componentDidMount() {
    window.addEventListener('scroll', throttle(this.checkWindowScroll, this.props.throttle));
    window.removeEventListener('resize', throttle(this.checkWindowScroll, this.props.throttle));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', throttle(this.checkWindowScroll, this.props.throttle));
    window.removeEventListener('resize', throttle(this.checkWindowScroll, this.props.throttle));
  }

  checkWindowScroll = () => {
    if (this.props.isLoading) {
      return;
    }

    if (
      this.props.hasMore &&
      this.sentinel &&
      this.sentinel.getBoundingClientRect().top - window.innerHeight < this.props.threshold!
    ) {
      this.props.onLoadMore();
    }
  };

  render() {
    return (
      <div className={this.props.className}>
        {this.props.children}
        <div id="sentinel" ref={i => (this.sentinel = i!)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/InfiniteList.tsx